var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.shopTheme === "type_1"
    ? _c("Footer1", { attrs: { data: _vm.getFooterSettings } })
    : _vm.shopTheme === "type_2"
    ? _c("Footer2", { attrs: { data: _vm.getFooterSettings } })
    : _vm.shopTheme === "type_3"
    ? _c("Footer3", { attrs: { data: _vm.getFooterSettings } })
    : _vm.shopTheme === "type_4"
    ? _c("Footer4", { attrs: { data: _vm.getFooterSettings } })
    : _vm.shopTheme === "type_5"
    ? _c("Footer5", { attrs: { data: _vm.getFooterSettings } })
    : _vm.shopTheme === "type_6"
    ? _c("Footer6", { attrs: { data: _vm.getFooterSettings } })
    : _vm.shopTheme === "type_7"
    ? _c("Footer7", { attrs: { data: _vm.getFooterSettings } })
    : _c("Footer3", { attrs: { data: _vm.getFooterSettings } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }